
import HoursPageProjects from '../projects';
import HoursPageTimesheet from '../timesheet';

export default function RegisterTab() {
    return (
        <>
            <HoursPageTimesheet />
            <div className="flex flex-wrap ">
                <HoursPageProjects type="organisation" />
                <HoursPageProjects type="private" />
            </div>
        </>
    );
}
